export const ANALYTICS_CONSENT = {
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  UNDECIDED: "undecided",
};

export const ANALYTICS_CONSENT_STORAGE_KEY = "makdis:analytics-consent";
export const ANALYTICS_CONSENT_EVENT = "makdis:analytics-consent-change";

function hasBrowserStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

function normalizeConsent(value) {
  if (value === ANALYTICS_CONSENT.ACCEPTED || value === ANALYTICS_CONSENT.REJECTED) {
    return value;
  }

  return ANALYTICS_CONSENT.UNDECIDED;
}

function dispatchConsentChange(consent) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(ANALYTICS_CONSENT_EVENT, {
      detail: { consent },
    })
  );
}

export function readAnalyticsConsent() {
  if (!hasBrowserStorage()) return ANALYTICS_CONSENT.UNDECIDED;

  try {
    return normalizeConsent(window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY));
  } catch {
    return ANALYTICS_CONSENT.UNDECIDED;
  }
}

export function writeAnalyticsConsent(consent) {
  const normalized = normalizeConsent(consent);

  if (hasBrowserStorage()) {
    try {
      if (normalized === ANALYTICS_CONSENT.UNDECIDED) {
        window.localStorage.removeItem(ANALYTICS_CONSENT_STORAGE_KEY);
      } else {
        window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, normalized);
      }
    } catch {
      // Consent still changes for this runtime, even if storage is unavailable.
    }
  }

  dispatchConsentChange(normalized);
  return normalized;
}

export function acceptAnalyticsConsent() {
  return writeAnalyticsConsent(ANALYTICS_CONSENT.ACCEPTED);
}

export function rejectAnalyticsConsent() {
  return writeAnalyticsConsent(ANALYTICS_CONSENT.REJECTED);
}

export function resetAnalyticsConsent() {
  return writeAnalyticsConsent(ANALYTICS_CONSENT.UNDECIDED);
}

export function onAnalyticsConsentChange(callback) {
  if (typeof window === "undefined") return () => {};

  const handler = (event) => callback(normalizeConsent(event.detail?.consent));
  window.addEventListener(ANALYTICS_CONSENT_EVENT, handler);

  return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, handler);
}
